<app-themed-background [theme]="theme"></app-themed-background>

<div class="container">
  <div class="main-card">
    <app-loading-shade [isLoading]="isLoading"></app-loading-shade>

    <div class="title-bar">
      <h1>Change Avatar</h1>

      <div class="title-right">
        @if (totalPrice > 0) {
          <app-user-economy [amount]="totalPrice"></app-user-economy>
          @if (!isBuyingParts) {
            <button
              mat-raised-button
              [appThemedButton]="theme"
              [disabled]="missingRequiredSlotNames.length > 0"
              (click)="onClickBuy()"
            >
              Buy
            </button>
          }
          @if (isBuyingParts) {
            <mat-spinner diameter="32"></mat-spinner>
          }
        }

        <button
          mat-raised-button
          [appThemedButton]="theme"
          (click)="onSubmit()"
          [disabled]="isSubmitDisabled"
        >
          Save
        </button>
      </div>
    </div>

    @if (missingRequiredSlotNames.length > 0) {
      <app-error-message
        [message]="'ยังไม่มีชิ้นส่วนสำหรับช่องที่จำเป็น: ' + missingRequiredSlotNames.join(', ')"
      ></app-error-message>
    }

    <div class="content-grid">
      <div class="left">
        <div class="image-item">
          <app-select-avatar-image-preview></app-select-avatar-image-preview>
        </div>
      </div>

      <div>
        <div class="slider-item">
          <app-tag-menu
            [theme]="theme"
            [labels]="slotLabels"
            [selectedIndex]="selectedSlotIndex"
            (clickMenu)="onClickSlotMenu($event)"
          ></app-tag-menu>
        </div>

        <div class="select-item">
          <app-select-avatar-item-select [theme]="theme"></app-select-avatar-item-select>
        </div>
      </div>
    </div>
  </div>
</div>
